import { rootElement } from '@shared/setup';
import ChooseAccount from './ChooseAccount.vue';

const initChooseAccount = async () => {
    rootElement({
        name: 'ChooseAccount', // pascal, camel & kebab-case are valid
        component: ChooseAccount,
        vm: {},
        contextComponents: ['<div>Waiting...</div>'],
    });
};

initChooseAccount();
